export default __webpack_public_path__ + "static/media/pakistan2.e02b8428.jpg";